// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesListHeaderStyles } from "@vanmeter/Overrides/Components/CartLinesListHeader";
import { color, createLinkIconStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";
import Edit from "@vanmeter/XDL/Icons/IconEdit";

cartLinesListHeaderStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding-bottom: 12px;
        &:has(> *:empty:only-child) {
            display: none;
        }
    `,
};
cartLinesListHeaderStyles.editLinkWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 20px;
    `,
};

cartLinesListHeaderStyles.editLink = {
    ...createLinkIconStyles({
        icon: Edit,
        iconSize: { width: 12 },
        sizeVariant: "small",
    }),
};

cartLinesListHeaderStyles.customHeading = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};
